import React, { CSSProperties, FC } from 'react'

import BlackBrick from './brick-variants/Plate_2x2_Black_RGB.svg'
import CoralBrick from './brick-variants/Plate_2x2_Coral_RGB.svg'
import EarthBrick from './brick-variants/Plate_2x2_Earth_Blue_RGB.svg'
import NougatBrick from './brick-variants/Plate_2x2_Nougat_RGB.svg'
import OffWhiteBrick from './brick-variants/Plate_2x2_Off_White_RGB.svg'
import SandBrick from './brick-variants/Plate_2x2_Sand_RGB.svg'
import TealBrick from './brick-variants/Plate_2x2_Teal_RGB.svg'
import WarmYellowBrick from './brick-variants/Plate_2x2_Warm_Yellow_RGB.svg'

export enum BrickColor {
  Coral = 'coral',
  Black = 'black',
  EarthBlue = 'earth-blue',
  Nougat = 'nougat',
  OffWhite = 'off-white',
  Sand = 'sand',
  Teal = 'teal',
  WarmYellow = 'warm-yellow',
}

interface BrickProps {
  className?: string
  brickColor?: BrickColor
  style?: CSSProperties
}

export const Brick: FC<BrickProps> = ({ className, brickColor = 'coral', style }) => {
  // Import the SVG files for different brick variants

  // Determine which SVG to return based on the brickColor prop
  const getBrickSVG = (color: string) => {
    switch (color) {
      case 'coral':
        return CoralBrick
      case 'black':
        return BlackBrick
      case 'earth-blue':
        return EarthBrick
      case 'nougat':
        return NougatBrick
      case 'off-white':
        return OffWhiteBrick
      case 'sand':
        return SandBrick
      case 'teal':
        return TealBrick
      case 'warm-yellow':
        return WarmYellowBrick
      default:
        return CoralBrick
    }
  }

  const BrickSVG = getBrickSVG(brickColor)

  // return BrickSVG as svg with className prop
  return <img alt={'Brick'} className={className} src={BrickSVG} style={style} />
}
